import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SettingsModal = ({ onClose, onContact, onShare }) => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{t('settings')}</h2>
        <div className="settings-content">
          <div className="language-selector" style={{ 
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '15px'
          }}>
            <span className="settings-label">{t('languageSelect')}</span>
            <div className="language-buttons">
              <button 
                className={`text-button ${language === 'en' ? 'active' : ''}`}
                style={{ minWidth: '80px' }}
                onClick={() => setLanguage('en')}
              >
                English
              </button>
              <button 
                className={`text-button ${language === 'ko' ? 'active' : ''}`}
                style={{ minWidth: '80px' }}
                onClick={() => setLanguage('ko')}
              >
                한국어
              </button>
            </div>
          </div>
          <div className="settings-buttons" style={{ display: 'flex', gap: '10px', margin: '20px auto' }}>
            <button 
              className="text-button"
              onClick={() => {
                onClose();
                onContact();
              }}
            >
              {t('contact')}
            </button>
            <button 
              className="text-button"
              onClick={() => {
                onClose();
                onShare();
              }}
            >
              {t('share')}
            </button>
          </div>
        </div>
        <div className="modal-buttons">
          <button onClick={onClose}>{t('close')}</button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal; 